var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{attrs:{"title":_vm.BackTitle,"left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }